import { ThisConnector } from '../../../../api/connector'
import { BaseApiResponse } from '../../../../api/shared'
import { SourceName } from '../../index'

export interface EditSourceNameArgs {
  organizationUuid: string
  sourceName: Partial<SourceName> &
    Pick<SourceName, 'id' | 'name' | 'cidrBlocks'>
}

export async function editSourceName(
  this: ThisConnector,
  { organizationUuid, sourceName }: EditSourceNameArgs
) {
  const { id, name, start, expiration, cidrBlocks } = sourceName
  return this.connector.put<BaseApiResponse>(
    `/${organizationUuid}/protect/sourcename/${id}`,
    {
      name,
      start: start && new Date(start).getTime(),
      expiration: expiration && new Date(expiration).getTime(),
      cidr_blocks: cidrBlocks
    }
  )
}
